import { Component } from '@angular/core';
import { AuthService } from '../../Services/auth.service';

@Component({
  selector: 'app-blog-nav-page',
  standalone: false,
  templateUrl: './blog-nav-page.component.html',
  styleUrl: './blog-nav-page.component.css'
})
export class BlogNavPageComponent {
  menuItems = [
    { path: "addblogPost", label: "Add Blog Post", icon: "pi pi-plus" },
    { path: "blogposts", label: "Manage Blog Post", icon: "pi pi-pencil" },
  ];

  getIcon(path: string): string {
    const iconMap: { [key: string]: string } = {
      "addblogPost": "pi pi-plus",
      "blogposts": "pi pi-pencil",
    };
    return iconMap[path] || "bi bi-circle";
  }

  userRole: string;

  constructor(private auth: AuthService) {
    this.userRole = this.auth.getRoles();
  }
}
